import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APICoreService } from 'src/app/common/services/api-core/api-core.service';

export interface ApiKeyResponse {
  api_key: string;
}

@Injectable({
  providedIn: 'root',
})
export class UserApiKeyService {
  constructor(private apiCore: APICoreService) {}

  regenerateApiKey(): Observable<ApiKeyResponse> {
    return this.apiCore.postRequest('user/api-key/regenerate', {});
  }
}
